var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestedUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.75C13.2075 6.75 11.3438 8.61375 11.3438 10.9062C11.3438 13.155 13.1025 14.975 15.395 15.0538C15.465 15.045 15.535 15.045 15.5875 15.0538C15.605 15.0538 15.6137 15.0538 15.6312 15.0538C15.64 15.0538 15.64 15.0538 15.6488 15.0538C17.8888 14.975 19.6475 13.155 19.6562 10.9062C19.6562 8.61375 17.7925 6.75 15.5 6.75Z",
    fill: "#662D91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.945 17.3901C17.5037 15.7626 13.5225 15.7626 11.0637 17.3901C9.95247 18.1251 9.33997 19.1314 9.33997 20.2076C9.33997 21.2839 9.95247 22.2814 11.055 23.0164C12.28 23.8389 13.89 24.2501 15.5 24.2501C17.11 24.2501 18.72 23.8389 19.945 23.0164C21.0475 22.2726 21.66 21.2751 21.66 20.1901C21.6512 19.1226 21.0475 18.1164 19.945 17.3901ZM17.5387 19.4901L15.3337 21.6951C15.2287 21.8001 15.0887 21.8526 14.9487 21.8526C14.8087 21.8526 14.6687 21.7914 14.5637 21.6951L13.4612 20.5926C13.2512 20.3826 13.2512 20.0326 13.4612 19.8226C13.6712 19.6126 14.0212 19.6126 14.2312 19.8226L14.9487 20.5401L16.7687 18.7201C16.9787 18.5101 17.3287 18.5101 17.5387 18.7201C17.7575 18.9301 17.7575 19.2801 17.5387 19.4901Z",
    fill: "#662D91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0249 19.9061L17.9749 20.8561L19.8749 18.9561",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 14.7939C15.5375 14.7876 15.4625 14.7876 15.3937 14.7939C13.9062 14.7439 12.725 13.5251 12.725 12.0251C12.7187 10.4939 13.9625 9.25012 15.4937 9.25012C17.025 9.25012 18.2687 10.4939 18.2687 12.0251C18.2687 13.5251 17.0812 14.7439 15.6 14.7939Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4938 21.6312C14.3563 21.6312 13.225 21.3437 12.3625 20.7687C10.85 19.7562 10.85 18.1062 12.3625 17.0999C14.0813 15.9499 16.9 15.9499 18.6188 17.0999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestedUsers);
export default __webpack_public_path__ + "static/media/invested-users.e36377bf54abb34372a5a41d326cb998.svg";
export { ForwardRef as ReactComponent };